import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    dateTime: Yup.date().nullable().required("Please select date/time"),
    entry: Yup.string().nullable().required("This field cannot be empty")
});

